<div class="container">
  <div class="works" *ngIf="shift?.type == 1"
       [ngStyle]="{'margin-top.px': getOffset(shift?.start), 'height.px': height}">

  </div>

</div>
